export default "__VITE_ASSET__7hin7pFf__"